import dedent from 'dedent-js';
import _ from 'lodash';
import moment from 'moment';
import { salutation } from 'utils/enums';
import { EmailDynamicSubstitutionObject } from 'features/References';

const readableSalutations = salutation().reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {});

const referenceVariableMapping: Record<string, string> = {
  'Candidate first name': 'candidate.first_name',
  'First name': 'candidate.first_name',
  'Candidate last name': 'candidate.last_name',
  'Last name': 'candidate.last_name',
  'Candidate phone': 'candidate.profile.phone_cell',
  'Phone number': 'candidate.profile.phone_cell',
  'Job title': 'role.title',
  'Sender first name': 'sender.first_name',
  'Sender last name': 'sender.last_name',
  'School name': 'sender.profile.school.name',
  'District name': 'sender.profile.district.name',
  'Interview date & time': 'application.interview.when',
  'Reference salutation': 'reference.salutation',
  'Reference first name': 'reference.first_name',
  'Reference last name': 'reference.last_name',
  'Reference email': 'reference.email',
  'Reference phone': 'reference.phone',
} as const;

export const processText = (initialText: string, outerObject: EmailDynamicSubstitutionObject) => {
  const deDentedText = dedent(initialText);
  const processedText = deDentedText.replace(/\{.*?\}/g, (content: string) =>
    useDynamicSubstitution(content, outerObject, referenceVariableMapping)
  );
  return processedText;
};

export const useDynamicSubstitution = (
  inputString: string,
  outerObject: EmailDynamicSubstitutionObject,
  variableMapping: Record<string, string> = referenceVariableMapping
) => {
  if (!_.startsWith(inputString, '{') || !_.endsWith(inputString, '}')) {
    return '';
  }

  const trimmedInput = _.trim(inputString, '{}');
  const mappedPath = variableMapping[trimmedInput];

  if (!mappedPath) {
    return '';
  }

  const pathSegments = _.split(mappedPath, '.');

  if (pathSegments[0] === 'reference') {
    if (pathSegments[1] === 'salutation') {
      return readableSalutations[outerObject.reference?.salutation] || '';
    }
    if (pathSegments[1] === 'first_name') {
      const fullName = outerObject.reference?.name;
      const firstName = fullName ? fullName.substr(0, fullName.indexOf(' ')) : '';
      return firstName || fullName;
    }
    if (pathSegments[1] === 'last_name') {
      const fullName = outerObject.reference?.name;
      return fullName ? fullName.substr(fullName.indexOf(' ') + 1) : '';
    }
  }

  if (pathSegments[0] === 'role') {
    return outerObject.role?.[pathSegments[1]] || '';
  }

  const resolvedValue = pathSegments.reduce((currentObject, segment) => {
    if (currentObject && segment in currentObject) {
      return currentObject[segment];
    }
    return null;
  }, outerObject);

  if (resolvedValue instanceof Date) {
    return moment.utc(resolvedValue).format('dddd, MMMM Do YYYY, h:mm a');
  }

  return resolvedValue || '';
};
